export type { ThemeProviderProps } from './types/ThemeProviderProps';
export { palette as BRAND } from './v1/colors';
export { palette } from './v1/colors';
export { ThemeCompositionProvider } from './theme-provider.composition';
export { GlobalStyles } from './globalStyles';
